import React, { useEffect, useRef } from 'react';
import { createInlineWidget, ITheme, IText, InlineWidget } from '@highloop/feedback';

export let FeedbackWidget = ({
  id,
  resetOnSubmit,
  theme,
  text,
  meta,
  expanded
}: {
  id: string;
  resetOnSubmit?: number | boolean;
  theme?: ITheme;
  text?: IText;
  meta?: any;
  expanded?: boolean;
}) => {
  let ref = useRef<HTMLDivElement>();
  let instanceRef = useRef<InlineWidget>();

  useEffect(() => {
    if (!ref.current || typeof window == 'undefined') return;

    createInlineWidget(id, ref.current, {
      meta,
      resetOnSubmit,
      theme,
      text,
      expanded
    })
      .then(instance => {
        instanceRef.current = instance;
      })
      .catch(err => console.warn('[highloop-feedback]: Could not create widget', err));

    return () => {
      if (!instanceRef.current) return;
      instanceRef.current.destroy();
    };
  }, [id]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setTheme(theme);
  }, [theme]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setMeta(meta);
  }, [meta]);

  return <div ref={ref} />;
};
